import styled from "@emotion/native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Text from "../Text";

export const Container = styled.View({
	position: "absolute",
	width: "100%",
	height: "100%",
	top: 0,
	alignItems: "center",
	paddingBottom: 100,
	justifyContent: "flex-end",
	flex: 1,
	backgroundColor: "rgba(0,0,0,.75)",
	zIndex: 11,
});

export const Body = styled(Text)({
	width: 235,
});

export const ArrowLoopContainer = styled.View(
	{
		position: "absolute",
		width: 72,
		height: 72,
		right: 78,
	},
	() => {
		const insets = useSafeAreaInsets();
		const bottom = 10 + insets.bottom / 2;

		return {
			bottom,
		};
	}
);
